export default __webpack_public_path__ + "b6696a237226ecea9dbf2da94adda9ac.otf";